import React from 'react';
import {RootState} from "../../../../../../reducers";
import {getSession} from "../../../../../services/Session/reducer";
import {getCart} from "../../../../../services/Cart/reducer";
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {OrderType} from "../../../../../services/Api/types";
import {ReactComponent as DineInSVG} from "../../../../../../images/icons/dine-in.svg";
import {getStoreConfig} from "../../../../../services/Store/reducer";
import ChangeTableNumberModal from "../../../../Modal/ChangeTableNumberModal";

interface OwnProps {
    loading: boolean;
    orderType: OrderType;
    handleChangeType: (
        event: any,
        value?: string,
    ) => Promise<void>;
    handleOnTypeLabelKeyDown: (
        orderType: string,
    ) => (event: (React.KeyboardEvent<HTMLLabelElement> | KeyboardEvent)) => Promise<void>;
    tableNumberModal: boolean;
    setTableNumberModal: React.Dispatch<React.SetStateAction<boolean>>;
    drawOpenHours: (
        orderType: OrderType,
    ) => JSX.Element;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartPageDineInOption = ({
                                  handleOnTypeLabelKeyDown,
                                  cart,
                                  loading,
                                  orderType,
                                  handleChangeType,
                                  session,
                                  tableNumberModal,
                                  setTableNumberModal,
                                  config,
                                  drawOpenHours
                              }: Props) => {
    const {t} = useTranslation();
    const tableNumber = session.table_number;
    const checked = orderType === OrderType.DINE_IN;

    if (config?.ordering.dine_in || orderType === OrderType.DINE_IN) {
        return (
            <label onKeyDown={handleOnTypeLabelKeyDown(OrderType.DINE_IN)} tabIndex={0} aria-checked={checked}
                   className={`btn btn-default btn-lg btn-check-full btn-spinner${(cart.pending || loading) ? " loading" : ""}${orderType === OrderType.DINE_IN ? " active" : ""}`}>
                <DineInSVG/>
                <span>
                    <p className="mb-0">{t("enums.order.type.DINE_IN")}</p>
                    {drawOpenHours(OrderType.DINE_IN)}
                </span>
                <input className="btn-check1" type="radio" name="type" value={OrderType.DINE_IN} autoComplete="off"
                       tabIndex={-1}
                       checked={checked} onChange={handleChangeType}/>
                <div className="spinner-border spinner-border-sm"/>
                <ChangeTableNumberModal tableName={tableNumber} show={tableNumberModal}
                                        onSave={() => setTableNumberModal(false)}
                                        onHide={() => setTableNumberModal(false)}/>
            </label>
        )
    }

    return <></>;
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    cart: getCart(state.cart),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartPageDineInOption));
